export default "__VITE_ASSET__D_FQxy3___"